/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import * as _ from 'lodash';
import {OBJECT_TYPE} from '../common/constants/object-type';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {ListDefaultActionsComponent} from '../common/directives/list-default-actions.component';
import {ReportRequesterComponent} from './widget/report-requester.component';
import {ReportExecutionResource} from '../../components/api/resources/resource/execution-resources/report-execution.resource';
import {PERMISSIONS} from '../../components/auth/auth-constants';



export function reportStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.rep.reports', {
          url: '/reports',
          resolve: {
            listNewStateName: function() {
              return 'app.rep.reports.new';
            },
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.runReports.apiKey);
            }
          },
          views: {
            'content@app': { component: getRoutePageComponent('report-route') },
            'context@app': {
              component: ListDefaultActionsComponent,
              bindings: {readOnly: 'readOnly', newStateName: 'listNewStateName'}
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "report.plural"
          }
        }).state('app.rep.reports.new', {
          url: '/new',
          resolve: {
            ResourceFactory: function() {
              return adnRouterHelper.services.resource(ReportExecutionResource);
            },
            ChildResourceFactory: function() {
            },
            orderByParam: function() {
              return 'DESCexecutionStartTime';
            },
            objectType: function() {
              return OBJECT_TYPE.ReportExecution;
            }
          },
          views: {
            'content@app': {
              component: ReportRequesterComponent
            },
            'context@app': {},
            'title@app': stateTitleView()
          },
          data: {
            title: 'Request a Report'
          }
        });
  }, adnRouterHelper);
}
